import { observer } from 'mobx-react-lite';
import React from 'react';
import { useWebsocketStore } from '../../../../../../../stores/websocketStore/websocketProvider';
import SoftOrderWrapper from '../../../../../tradeplans/softOrderModules/softOrderWrapper/SoftOrderWrapper';
import { lineComponentMap } from '../../../../../tradeplans/softOrderModules/tacticMap/componentMaps';
interface Props {
  tradePlanId: string;
  symbol?: string;
  size?: number;
  scaleY?: (value: number) => number;
  portalRef?: {
    current: any;
  };
}
const SoftOrdersContainer: React.FC<Props> = observer(
  ({ tradePlanId, ...rest }: Props) => {
    const { tradePlanStore } = useWebsocketStore();
    const softOrderArray: string[] =
      tradePlanStore.softOrderIdsByTradePlan[tradePlanId] ?? null;
    return (
      <g>
        {softOrderArray &&
          softOrderArray.map((softOrderId) => {
            return (
              <SoftOrderWrapper
                tradePlanId={tradePlanId}
                key={softOrderId}
                softOrderId={softOrderId}
                componentMap={lineComponentMap}
                {...rest}
              />
            );
          })}
      </g>
    );
  }
);

export default SoftOrdersContainer;
